export const saveImage = (
  data: Blob,
  type: "png" | "zip",
  setIsCreated: (isCreated: boolean) => void
) => {
  let blob;
  switch (type) {
    case "png":
      blob = new Blob([data], { type: "image/png" });
      break;
    case "zip":
      blob = new Blob([data], { type: "application/zip" });
      setIsCreated(true);
      break;
  }
  const previewImage = window.URL.createObjectURL(blob);
  let tempLink;
  tempLink = document.createElement("a");
  tempLink.href = previewImage;
  tempLink.setAttribute("download", `preview-image.${type}`);
  tempLink.click();
};
